import React from "react";

import { Info } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../intelligence-briefing-library/components/ui/tooltip";
import { AccountBriefingLegendContent } from "../../AlwaysOnChannel/Dashboard/components/AccountBriefingLegend";

type SynopsisLegendInfoProps = {
  label: string;
};

const SynopsisLegendInfo: React.FC<SynopsisLegendInfoProps> = ({ label }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex h-4 w-4 shrink-0 cursor-help items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-gray-400 transition-colors hover:border-purple-300 hover:bg-purple-50 hover:text-purple-600 focus:outline-none focus-visible:border-purple-400 focus-visible:text-purple-600 data-[state=open]:border-purple-300 data-[state=open]:bg-purple-50 data-[state=open]:text-purple-600"
          aria-label={`About ${label}`}
        >
          <Info className="h-2.5 w-2.5" strokeWidth={2.5} aria-hidden />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="start"
        sideOffset={8}
        className="z-[9999] w-max max-w-[min(96vw,40rem)] border border-gray-200 bg-white p-3 text-left font-normal normal-case tracking-normal text-gray-800 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
      >
        <AccountBriefingLegendContent compact />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default SynopsisLegendInfo;
